import { createContext } from "react";

const coreContext = createContext()

export default coreContext